import { TenantHelpers } from '@/utils/tenant-helpers'

export namespace UserConst {
  export enum inviteStatus {
    default = '',
    accept = 'accept',
    pending = 'pending',
    failed = 'failed',
  }

  export const inviteStatusTag: Record<inviteStatus | string, string> = {
    [inviteStatus.default]: '',
    [inviteStatus.accept]: 'Accepted',
    [inviteStatus.pending]: 'Invite sent',
    [inviteStatus.failed]: 'Failed',
    sso: 'SSO',
  }

  export const defaultUserAttribtes = {
    SignupFirstName: '',
    SignupLastName: '',
    SignupType: '',
    SignupRole: '',
    SignupUsecase: '',
    SignupOrganisationName: '',
  }

  export const defaultTenantUser = {
    ID: TenantHelpers.InvalidTenantUserID,
    Uid: 0,
    dateCreated: new Date(),
    email: '',
    name: '',
    roles: [],
    status: '',
    tenantId: TenantHelpers.InvalidTenantID,
    user_attributes_json: defaultUserAttribtes,
    username: '',
    permissions: {},
    tenantAdminRoles: [],
    extraPermissionNames: [],
    inviteDate: null,
    inviteId: null,
    inviteStatus: inviteStatus.default,
    usesSSOToLogin: false,
  }
}
